import { imageBaseName } from './imageLicensing.js';
import { BRAND_INSTALL_PHOTOS } from './brandInstallImages.js';
import { RECLAIMED_JOB_PHOTOS } from './reclaimedOldeImages.js';

export const MANUFACTURER_NAMES = {
  mercier: 'Mercier Wood Flooring', lauzon: 'Lauzon', viking: 'Viking Hardwood',
  'olde-wood': 'Olde Wood Ltd', 'quick-step': 'Quick Step', indusparquet: 'Indusparquet',
  cali: 'Cali', 'bella-cera': 'Bella Cera', alterna: 'Armstrong Flooring', ironwood: 'Ironwood',
};

const projectBasenames = new Set([
  ...Object.values(BRAND_INSTALL_PHOTOS).flat().map(photo => photo.baseName),
  ...RECLAIMED_JOB_PHOTOS.map(photo => photo.baseName),
]);

export function manufacturerForPath(path) {
  const parts = path.replace(/\/+$/, '').split('/');
  return parts[1] === 'brands' ? MANUFACTURER_NAMES[parts[2]] : undefined;
}

export function isManufacturerPhotoRecord(image) {
  return Object.values(MANUFACTURER_NAMES).includes(image.creator?.name)
    && image.creditText === `Photo courtesy of ${image.creator.name}`;
}

export function makeManufacturerPhotoSchemas(path, photos) {
  const manufacturer = manufacturerForPath(path);
  if (!manufacturer) return [];
  const seen = new Set();
  return photos.flatMap(photo => {
    if (!photo.src || !photo.alt || /logo|certification|certified|badge/i.test(photo.alt)
      || projectBasenames.has(imageBaseName(photo.src))) return [];
    const url = new URL(photo.src, 'https://1woodfloors.com').href;
    if (seen.has(url)) return [];
    seen.add(url);
    return [{
      '@context': 'https://schema.org', '@type': 'ImageObject',
      '@id': `https://1woodfloors.com${path}#manufacturer-photo-${encodeURIComponent(url)}`,
      contentUrl: url, caption: photo.alt,
      creator: { '@type': 'Organization', name: manufacturer },
      creditText: `Photo courtesy of ${manufacturer}`,
      copyrightNotice: `© ${manufacturer}`,
    }];
  });
}

export function collectManufacturerPhotoSchemas(document, path) {
  const brand = path.split('/')[2];
  const brandAlt = {
    mercier: /^Mercier/i, lauzon: /^(Expert by Lauzon|Lauzon)/i, viking: /^Viking/i,
    'olde-wood': /^Olde Wood/i, 'quick-step': /^Quick.Step/i, indusparquet: /^Indusparquet/i,
    cali: /^CALI/i, 'bella-cera': /^Bella Cera/i, alterna: /^Armstrong Alterna/i,
    ironwood: /^(?!1 Wood Floors|Dining room|Michigan Plank)/i,
  }[brand];
  if (!brandAlt) return [];
  return makeManufacturerPhotoSchemas(path, Array.from(document.querySelectorAll('#root img'))
    .filter(image => !image.closest('header, footer, nav, [role="dialog"]'))
    .filter(image => brandAlt.test(image.alt) && !image.getAttribute('src')?.includes('/images/projects/'))
    .map(image => ({ src: image.getAttribute('src'), alt: image.alt })));
}